export let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

let ticking = false;
const scrollFunctions = [];

function animate() {
    scrollFunctions.forEach(funcRef => funcRef());
    ticking = false;
}

function requestTick() {
    if (!ticking) {
        requestAnimationFrame(animate);
        ticking = true;
    }
}

function scrollHandler() {
    scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    requestTick();
}

export function onScroll(handler, triggerNow = false) {
    !scrollFunctions.length ? initScroll() : null;
    triggerNow ? handler() : null;
    scrollFunctions.push(handler);
}

export function initScroll() {
    window.addEventListener('scroll', scrollHandler);
}

export function scrollTo(target) {
    if (typeof target === 'string' || target instanceof String) {
        if (target.toLowerCase() == 'top') {
            window.scrollTo({
                top: 0,
                left: 0
            });
        } else if (target.toLowerCase() == 'bottom') {
            window.scrollTo({
                top: document.body.scrollHeight,
                left: 0
            });
        } else if (target.startsWith('#')) {
            const targetElm = document.getElementById(target.replace('#', ''));
            if (targetElm) {
                targetElm.scrollIntoView({
                    block: 'start',
                    inline: 'nearest'
                });
            }
        }
    } else if (target) {
        target.scrollIntoView({
            block: 'start',
            inline: 'nearest'
        });
    }
}
